import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import PrimaryButton from '../ui/PrimaryButton';

const { FiPackage } = FiIcons;

const brands = ['Apple', 'Samsung', 'Google', 'OnePlus', 'Motorola', 'LG', 'Other'];
const conditions = [
  { value: 'excellent', label: 'Excellent', desc: 'Like new, no scratches' },
  { value: 'good', label: 'Good', desc: 'Minor wear, fully functional' },
  { value: 'fair', label: 'Fair', desc: 'Visible scratches, works fine' },
  { value: 'poor', label: 'Poor', desc: 'Cracked screen or major damage' },
];

export default function Step2bTradeIn({ onSubmit }) {
  const [brand, setBrand] = useState('');
  const [model, setModel] = useState('');
  const [storage, setStorage] = useState('');
  const [condition, setCondition] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (brand && model && condition) onSubmit({ brand, model, storage, condition });
  };

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="card-premium">
      <div className="text-center mb-8">
        <div className="w-14 h-14 bg-indigo-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
          <SafeIcon icon={FiPackage} className="w-7 h-7 text-indigo-600" />
        </div>
        <h2 className="text-3xl font-bold text-slate-900 mb-2">Tell Us About Your Device</h2>
        <p className="text-slate-600">We'll calculate a trade-in value to offset your carrier balance.</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">Phone Brand</label>
          <div className="flex flex-wrap gap-2">
            {brands.map((b) => (
              <button
                key={b}
                type="button"
                onClick={() => setBrand(b)}
                style={{
                  background: brand === b ? 'linear-gradient(135deg, #2563eb, #4f46e5)' : '#fff',
                  color: brand === b ? '#fff' : '#475569',
                  border: brand === b ? '2px solid transparent' : '2px solid #e2e8f0',
                  boxShadow: brand === b ? '0 2px 8px rgba(37,99,235,0.25)' : '0 1px 3px rgba(0,0,0,0.06)',
                  cursor: 'pointer',
                  fontWeight: 600,
                  padding: '8px 16px',
                  borderRadius: '12px',
                  transition: 'all 0.2s',
                  fontSize: '14px',
                }}
              >
                {b}
              </button>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">Model Name / Number</label>
          <input
            type="text"
            required
            placeholder="e.g. iPhone 14 Pro, Galaxy S23"
            value={model}
            onChange={(e) => setModel(e.target.value)}
            className="input-premium"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">Storage Capacity (optional)</label>
          <select
            value={storage}
            onChange={(e) => setStorage(e.target.value)}
            className="input-premium"
          >
            <option value="">Select storage...</option>
            {['64GB', '128GB', '256GB', '512GB', '1TB'].map((s) => <option key={s}>{s}</option>)}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">Device Condition</label>
          <div className="grid grid-cols-2 gap-3">
            {conditions.map((c) => (
              <button
                key={c.value}
                type="button"
                onClick={() => setCondition(c.value)}
                style={{
                  background: condition === c.value ? 'linear-gradient(135deg, #eff6ff, #eef2ff)' : '#f8fafc',
                  border: condition === c.value ? '2px solid #2563eb' : '2px solid #e2e8f0',
                  borderRadius: '14px',
                  padding: '16px',
                  textAlign: 'left',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  boxShadow: condition === c.value ? '0 2px 8px rgba(37,99,235,0.15)' : 'none',
                }}
              >
                <div style={{ fontWeight: 700, fontSize: '14px', color: condition === c.value ? '#1d4ed8' : '#1e293b' }}>{c.label}</div>
                <div style={{ fontSize: '12px', color: '#94a3b8', marginTop: '2px' }}>{c.desc}</div>
              </button>
            ))}
          </div>
        </div>

        <PrimaryButton type="submit" disabled={!brand || !model || !condition} className="w-full py-4 text-lg">
          Get My Trade-In Estimate
        </PrimaryButton>
      </form>
    </motion.div>
  );
}